var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConcentrate = function SvgConcentrate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#concentrate_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#061E21",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M2 8.08v1.76c0 1.44-1 .85-1 4.48v4.75c0 1.66 1.34 3 3 3h4c1.66 0 3-1.34 3-3v-4.75c0-3.71-1-2.88-1-4.48V8.08m-2 0H1.38m6.62 0 .5-3.045M8 8.08h2.64"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#061E21",
    d: "M8.74 6.155c.961 0 1.74-.81 1.74-1.81s-.779-1.81-1.74-1.81S7 3.345 7 4.345s.779 1.81 1.74 1.81"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#061E21",
    strokeLinecap: "round",
    strokeWidth: 1.83,
    d: "M11 14.5H1v4.05h10z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "concentrate_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v23.07H0z"
  })))));
};
export default SvgConcentrate;